import request from '@/utils/request'
import qs from 'qs'

// 获取验证码
export function getCodeImg () {
  return request({
    url: '/api/v1/captcha',
    method: 'get'
  })
}

// 发送短信验证码
export function sendSmsCode (data) {
  return request({
    url: '/api/v2/t-user/sms/send',
    method: 'post',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 发送邮箱验证码
export function sendEmailCode (data) {
  return request({
    url: '/api/v2/t-user/email/send',
    method: 'post',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 查询 此接口不在验证数据权限
export function getSetting () {
  return request({
    url: '/api/v1/app-config',
    method: 'get'
  })
}
